module.exports = __webpack_public_path__ + "assets/87619b32c9eb8ad6fcbae9e4651a580f.json";